import { render, staticRenderFns } from "./ExDebtShow.vue?vue&type=template&id=fb478462&scoped=true&"
import script from "./ExDebtShow.vue?vue&type=script&lang=js&"
export * from "./ExDebtShow.vue?vue&type=script&lang=js&"
import style0 from "./ExDebtShow.vue?vue&type=style&index=0&id=fb478462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb478462",
  null
  
)

export default component.exports